// src/design/forms/datepicker/calendar-engine/utilities/split_date.ts
var e = (e, t = "-") => {
	let [n, r, i] = e.split(t);
	return {
		day: parseInt(i, 10),
		month: parseInt(r, 10),
		year: parseInt(n, 10)
	};
};
export { e as split_date };

//# sourceMappingURL=split_date.js.map